<template>
  <div class="p-3" v-if="employee">
    <loading :active.sync="loader" :is-full-page="true" loader="bars"></loading>
    <b-row>
      <b-col sm="12" lg="12" md="12">
        <div class="flexDiv bg-primary text-white p-3">
          <div class="flexDiv2">
            <div
                class="avatar-md profile-user-wid mb-1"
                v-if="employee.employeePhotoUploadPath"
            >
              <b-avatar
                  class="m-0"
                  size="lg"
                  v-if="employee"
                  :src="
                  employee.employeePhotoUploadPath
                    ? `${baseUrl}/${employee.employeePhotoUploadPath}`
                    : require('@/assets/user.jpg')
                "
              ></b-avatar>
            </div>
            <div
                class="ml-3"
                v-if="
                passportDate && passportDate.firstName && passportDate.lastName
              "
            >
              <h5 class="m-0">
                {{ `${passportDate.lastName} ${passportDate.firstName}` }}
              </h5>
              <h5 v-if="passportDate && passportDate.parentName">
                {{ `${passportDate.parentName}` }}
              </h5>
              <p v-if="passportDate && passportDate.phone" class="m-0">
                {{ passportDate.phone }}
              </p>
            </div>
          </div>

          <div class="mb-2">
            <b-button-group>
              <b-button
                  variant="outline-light"
                  @click="editData"
                  style="min-width: 130px"
              >
                <i class="fa fa-edit"></i>
                {{ $t("actions.edit") }}
              </b-button>
            </b-button-group>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" lg="12" md="12">
        <div class="bg-white">
          <table class="table table-bordered table-responsive-sm">
            <tr>
              <td style="width: 33%">
                <p class="m-0 fo">{{ $t("employees.birthDate") }}</p>
                <strong class="str">{{ passportDate.birthday }}</strong>
              </td>

              <td style="width: 33%">
                <p class="m-0 fo">{{ $t("employees.birthAddress") }}</p>
                <strong class="str">
                  {{ passportDate[$localeKey("birthCountryName")] }}
                  {{ passportDate[$localeKey("birthRegionName")] }}
                  {{ passportDate[$localeKey("birthDistrictName")] }}
                </strong>
              </td>
              <td style="width: 33%">
                <p class="m-0 fo">{{ $t("references.propis") }}</p>
                <strong class="str">
                  {{ passportDate[$localeKey("directoryRegionAddressName")] }}
                  {{ passportDate.address }}
                </strong>
              </td>
            </tr>
            <tr>
              <td style="width: 33%">
                <p class="m-0 fo">{{ $t("references.exactAdress") }}</p>
                <strong class="str">
                  {{ passportDate[$localeKey("currentRegionAddressName")] }}
                  {{ passportDate.currentAddress }}
                </strong>
              </td>
              <td style="width: 34%">
                <p class="m-0 fo">{{ $t("seriaNumber") }}</p>
                <strong class="str">
                  {{ passportDate.passportSerialTitle }}
                  {{ passportDate.passportNumber }}
                </strong>
              </td>
              <td style="width: 33%">
                <p class="m-0 fo">{{ $t("employees.inpc") }}</p>
                <strong class="str">{{ passportDate.inps }}</strong>
              </td>
            </tr>
            <tr>
              <td style="width: 34%">
                <p class="m-0 fo">{{ $t("login.inn") }}</p>
                <strong class="str">{{ passportDate.inn }}</strong>
              </td>
              <td style="width: 33%">
                <p class="m-0 fo">{{ $t("references.nationality") }}</p>
                <strong class="str">
                  {{ passportDate[$localeKey("directoryNationalityName")] }}
                </strong>
              </td>
              <td style="width: 33%">
                <p class="m-0">{{ $t("references.gender") }}</p>
                <strong class="str">
                  {{ passportDate[$localeKey("directoryGenderName")] }}
                </strong>
              </td>
            </tr>

            <tr>
              <td style="width: 34%">
                <p class="m-0 fo">{{ $t("employees.passportGivenDate") }}</p>
                <strong class="str">{{
                    passportDate.passportGivenDate
                  }}</strong>
              </td>
              <td style="width: 33%">
                <p class="m-0">{{ $t("employees.passportEndDate") }}</p>
                <strong class="str">{{ passportDate.passportEndDate }}</strong>
              </td>
              <td style="width: 33%">
                <p class="m-0 fo">{{ $t("references.passportTYpe") }}</p>
                <strong class="str">
                  {{ passportDate[$localeKey("passportTypeName")] }}
                </strong>
              </td>
            </tr>

            <tr>
              <td style="width: 34%">
                <p class="m-0 fo">{{ $t("references.marital_status") }}</p>
                <strong class="str">
                  {{ passportDate[$localeKey("directoryMaritalStatusName")] }}
                </strong>
              </td>
              <td style="width: 33%">
                <p class="m-0 fo">{{ $t("employees.email") }}</p>
                <strong class="str">{{ passportDate.email }}</strong>
              </td>
              <td style="width: 33%">
                <p class="m-0 fo">{{ $t("employees.mobilePhone") }}</p>
                <strong class="str">{{ passportDate.mobilePhone }}</strong>
              </td>
            </tr>
          </table>
        </div>
      </b-col>
    </b-row>

    <b-modal
        :no-close-on-backdrop="true"
        :hide-header="true"
        :ok-title="$t('actions.yes')"
        :cancel-title="$t('actions.no')"
        @close="cancel"
        @cancel="cancel"
        @ok.once="ok"
        v-model="isModal"
    >
      <p>{{ $t("login.verify") }}</p>
    </b-modal>
  </div>
</template>

<script>
import {mapState, mapActions} from "vuex";
import {integer, maxLength, minLength, required} from "vuelidate/lib/validators";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import EmployeeService from "@/services/vacancy.service";
import {TokenService} from "@/services/storage.service";
import {validationMixin} from "vuelidate";

export default {
  components: {
    Loading,
  },
  mixins: [validationMixin],
  validations: {
    form: {
      inps: {
        required,
        integer,
        maxLength: maxLength(14),
        minLength: minLength(14)
      }
    }
  },

  data() {
    return {
      isModal: false,
      selectedVacancy: TokenService.getselectedVacancy(),

    };
  },
  computed: {
    ...mapState("auth", ["token"]),
    ...mapState("vacancy", [
      "vacancyIdOK",
      "selectedVacancyOK",
      "selectedVacancyYes",
    ]),
    ...mapState("employee", ["employee", "passportDate", "loader"]),
  },
  methods: {
    ...mapActions("employee", ["getEmployeePasportDate"]),
    async ok(v) {
      if (this.token && this.employee) {
        v.preventDefault();
        await EmployeeService.selectVakant(this.selectedVacancy.id)
            .then((res) => {
              this.$toast.success(this.$t("succes.SEND_DOCUMENT"));
              this.$router.push("/profile");
              this.selectedVacancy = null;
              TokenService.setselectedVacancy(null);
            })
            .catch((e) => {
              if (e.request.response == "selected") {
                this.$toast.info(this.$t("warning.selectInfo"));
              } else {
                this.$toast.info(this.$t("warning.warInfo"));
                this.$router.push("/profile");
              }
            });
      } else {
        this.$toast.info(this.$t("warning.loginInfo"));
        this.authModal = true;
      }
    },
    cancel() {
      this.isModal = false;
    },
    apply() {
      this.isModal = true;
    },
    editData() {
      this.$emit("editData", true);
    },
  },
  async created() {
    await this.getEmployeePasportDate(this.employee.id);
  },
};
</script>

<style>
.str {
  font-size: 15px !important;
}

.fo {
  font-size: 14px !important;
}

.flexDiv {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.flexDiv2 {
  display: flex;
  align-items: center;
}
</style>
